(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Comunidad_banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SELECTOR_SECTION = '.ja-comunidad';
  var MOBILE_BREAKPOINT = 768;
  var MOBILE_LIMIT = 8; // 👈 mostrar 8 fotos en móvil
  var instances = new Map();
  var mqlSupportsAddEventListener =
    typeof window.matchMedia('(min-width:1px)').addEventListener === 'function';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initSection(sectionEl) {
    var gallery = sectionEl.querySelector('.ja-comunidad__gallery');
    if (!gallery) return;

    var progress      = sectionEl.querySelector('.ja-comunidad__progress');
    var progressFill  = sectionEl.querySelector('.ja-comunidad__progress-fill');

    // Robustez: asegurar target/rel en enlaces
    sectionEl.querySelectorAll('a.ja-comunidad__link, a.ja-comunidad__social-link')
      .forEach(function (a) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener noreferrer');
      });

    var mql = window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)');
    var state = {
      section: sectionEl,
      gallery: gallery,
      mql: mql,
      isMobile: mql.matches,
      items: Array.from(sectionEl.querySelectorAll('.ja-comunidad__item'))
    };

    // Limitar items visibles en móvil y ocultar páginas vacías
    function limitToMobileCount() {
      if (state.isMobile) {
        state.items.forEach(function (el, idx) {
          el.style.display = (idx < MOBILE_LIMIT) ? '' : 'none';
        });
        Array.from(sectionEl.querySelectorAll('.ja-comunidad__page')).forEach(function (page) {
          var hasVisible = Array.from(page.children).some(function (child) {
            return child.classList &&
                   child.classList.contains('ja-comunidad__item') &&
                   child.style.display !== 'none';
          });
          page.style.display = hasVisible ? 'grid' : 'none';
        });
      } else {
        state.items.forEach(function (el) { el.style.display = ''; });
        Array.from(sectionEl.querySelectorAll('.ja-comunidad__page'))
          .forEach(function (page) { page.style.display = ''; });
      }
    }

    // Barra de progreso (solo móvil)
    var ticking = false;
    function updateProgress() {
      if (!progress || !progressFill) return;

      if (!state.isMobile) {
        progress.style.opacity = '0';
        return;
      }

      var maxScroll = state.gallery.scrollWidth - state.gallery.clientWidth;
      if (maxScroll <= 0) {
        progress.style.opacity = '0';
        progressFill.style.transform = 'scaleX(0)';
        return;
      }

      var ratio = Math.max(0, Math.min(1, state.gallery.scrollLeft / maxScroll));
      progressFill.style.transform = 'scaleX(' + ratio + ')';
      progress.style.opacity = '1';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateProgress();
        ticking = false;
      });
    }

    function applyMode() {
      state.isMobile = state.mql.matches;
      state.gallery.classList.toggle('is-carousel', state.isMobile);
      state.gallery.classList.toggle('is-grid', !state.isMobile);

      limitToMobileCount();

      // 🔧 Antes aquí se hacía scrollIntoView sobre la página (movía toda la web).
      // Ahora solo reseteamos el scroll horizontal cuando NO es móvil.
      if (!state.isMobile) {
        state.gallery.scrollLeft = 0;
      }

      updateProgress();
    }

    function onMqlChange() { applyMode(); }

    // Listeners
    if (mqlSupportsAddEventListener) state.mql.addEventListener('change', onMqlChange);
    else if (typeof state.mql.addListener === 'function') state.mql.addListener(onMqlChange);

    state.gallery.addEventListener('scroll', onScroll);
    window.addEventListener('resize', updateProgress);

    // Editor: al seleccionar bloque, centrar la página correspondiente (móvil)
    function onBlockSelect(e) {
      var blockId = e && e.detail && e.detail.blockId;
      if (!blockId) return;
      var blockEl = document.getElementById(blockId);
      if (!blockEl || !state.section.contains(blockEl) || !state.isMobile) return;

      var page = blockEl.closest('.ja-comunidad__page') || blockEl;
      var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
      try { page.scrollIntoView({ behavior: behavior, inline: 'start', block: 'nearest' }); }
      catch (err) { page.scrollIntoView(); }
      updateProgress();
    }
    document.addEventListener('shopify:block:select', onBlockSelect);

    // Init
    applyMode();

    // API de limpieza
    function destroy() {
      if (mqlSupportsAddEventListener) state.mql.removeEventListener('change', onMqlChange);
      else if (typeof state.mql.removeListener === 'function') state.mql.removeListener(onMqlChange);
      state.gallery.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', updateProgress);
      document.removeEventListener('shopify:block:select', onBlockSelect);
    }

    return { destroy: destroy };
  }

  // Bootstrap
  function initAll() {
    document.querySelectorAll(SELECTOR_SECTION).forEach(function (sectionEl) {
      if (instances.has(sectionEl)) return;
      var api = initSection(sectionEl);
      if (api) instances.set(sectionEl, api);
    });
  }

  function destroyBySectionId(sectionId) {
    var sectionEl = document.getElementById(sectionId);
    if (!sectionEl) return;
    var api = instances.get(sectionEl);
    if (api && api.destroy) api.destroy();
    instances.delete(sectionEl);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Hooks del editor
  document.addEventListener('shopify:section:load', function (e) {
    var id = e && e.detail && e.detail.sectionId;
    if (!id) return;
    var sectionEl = document.getElementById(id);
    if (sectionEl && sectionEl.matches(SELECTOR_SECTION)) {
      var api = initSection(sectionEl);
      if (api) instances.set(sectionEl, api);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var id = e && e.detail && e.detail.sectionId;
    if (!id) return;
    destroyBySectionId(id);
  });

  document.addEventListener('shopify:section:reorder', function () {
    instances.forEach(function (api) { api.destroy(); });
    instances.clear();
    initAll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
